// @flow

import * as React from 'react';
import classNames from '@ta/common.classnames';
import { Icon } from '@ta/styleguide.icon';
import { OverflowOpener, OverflowUIList } from '@ta/social.overflow-ui';
import styles from './ProfileOverflowButton.less';
import ProfileOverflowSelector, { type DataProps } from './ProfileOverflowSelector';

/** A wrapper component for an overflow menu to display options for a particular profile
 * Currently only supports blocking/unblocking, but will support reports as well.
 * */

const ProfileOverflowButton = ({ profileUserId, displayName, isBlocking }: DataProps) => (
  <ProfileOverflowSelector
    profileUserId={profileUserId}
    displayName={displayName}
    isBlocking={isBlocking}
  >
    {overflowItems =>
      overflowItems.length > 0 ? (
        <span>
          <OverflowOpener
            overflowList={<OverflowUIList>{overflowItems}</OverflowUIList>}
            shiftX={40}
            shiftArrow={32}
            shiftY={10}
          >
            {(target, toggle) => (
              <React.Fragment>
                <span ref={target} />
                <button className={classNames('ui_button', styles.greenless)} onClick={toggle}>
                  <Icon name="more-horizontal" className={styles.icon} />
                </button>
              </React.Fragment>
            )}
          </OverflowOpener>
        </span>
      ) : null
    }
  </ProfileOverflowSelector>
);

export default ProfileOverflowButton;
